import { Constants } from "../../../contants";
import {
  INITIATE_VIEW_FAMILY_DATA,
  SET_VIEW_FAMILY_DATA,
  SET_VIEW_FAMILY_DATA_FAIL,
  SET_FAMILY_SEARCH_QUERY,
} from "../../actionTypes/dashboard";

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  error: null,
  lastSearchQuery: "",
  paginationInfo: {
    currentPage: 0,
    totalPages: 1,
    totalElements: 0,
    pageSize: Constants.DEFAULT_PAGE_SIZE,
  },
};

// eslint-disable-next-line default-param-last
const reducer = (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case INITIATE_VIEW_FAMILY_DATA:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SET_VIEW_FAMILY_DATA:
      return {
        ...state,
        data: payload.data,
        paginationInfo: payload?.paginationInfo,
        isLoading: false,
      };
    case SET_FAMILY_SEARCH_QUERY:
      return {
        ...state,
        lastSearchQuery: payload,
      };
    case SET_VIEW_FAMILY_DATA_FAIL:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: payload,
      };

    default:
      return {
        ...state,
      };
  }
};

export default reducer;
